import React, { useState } from 'react';
import { Card, Descriptions, Typography, Button, Form, Input, Upload, message } from 'antd';
import { EditOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import { defaultAboutInfoTemplate } from '../../api/mockData';
import './index.css';

const { Title, Paragraph } = Typography;

const AboutPage = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [aboutInfo, setAboutInfo] = useState({
    ...defaultAboutInfoTemplate,
    ...JSON.parse(sessionStorage.getItem('userProfile') || '{}')
  });

  const handleEdit = () => {
    setIsEditing(true);
    form.setFieldsValue(aboutInfo);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const updatedInfo = { ...aboutInfo, ...values };
      setAboutInfo(updatedInfo);
      // 保存到本地存储
      sessionStorage.setItem('userProfile', JSON.stringify(updatedInfo));
      setIsEditing(false);
      message.success('个人信息更新成功！');
    } catch (error) {
      console.error('保存失败:', error);
      message.error('请检查输入信息');
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('只能上传图片文件!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片大小不能超过2MB!');
    }
    return isImage && isLt2M;
  };

  const handleChange = (info) => {
    if (info.file.status === 'done') {
      // 从响应中获取上传的图片URL
      const url = info.file.response?.url || URL.createObjectURL(info.file.originFileObj);
      form.setFieldsValue({ avatar: url });
      message.success(`${info.file.name} 上传成功!`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 上传失败!`);
    }
  };

  return (
    <div className="about-container">
      <Card 
        className="about-header" 
        title="关于我" 
        extra={
          isEditing ? (
            <>
              <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                取消
              </Button>
              <Button onClick={handleSave} type="primary" icon={<SaveOutlined />}>
                保存
              </Button>
            </>
          ) : (
            <Button onClick={handleEdit} type="primary" icon={<EditOutlined />}>
              编辑
            </Button>
          )
        } 
      />
      
      <Card className="about-card">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          {isEditing ? (
            <Form.Item
              name="avatar"
              valuePropName="src"
            >
              <Upload
                name="avatar"
                listType="picture-circle"
                className="avatar-uploader"
                showUploadList={true}
                action="/upload" // 实际项目中应替换为真实的上传接口
                beforeUpload={beforeUpload}
                onChange={handleChange}
                customRequest={(options) => {
                  // 模拟上传过程
                  setTimeout(() => {
                    options.onSuccess({ url: URL.createObjectURL(options.file) }, options.file);
                  }, 1000);
                }}
              >
                {form.getFieldValue('avatar') ? (
                  <img 
                    src={form.getFieldValue('avatar')} 
                    alt="avatar" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                  />
                ) : (
                  <div>
                    <UploadOutlined style={{ fontSize: '24px' }} />
                    <div style={{ marginTop: 8 }}>上传头像</div>
                  </div>
                )}
              </Upload>
            </Form.Item>
          ) : (
            <img 
              src={aboutInfo.avatar} 
              alt="头像" 
              style={{ 
                width: 120, 
                height: 120, 
                borderRadius: '50%', 
                objectFit: 'cover' 
              }} 
            />
          )}
        </div>
        
        {isEditing ? (
          <Form
            form={form}
            layout="vertical"
            initialValues={aboutInfo}
          >
            <Form.Item
              label="姓名"
              name="name"
              rules={[{ required: true, message: '请输入姓名!' }]}
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              label="个人介绍"
              name="intro"
              rules={[{ required: true, message: '请输入个人介绍!' }]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>
            
            <Form.Item
              label="邮箱"
              name="email"
              rules={[
                { required: true, message: '请输入邮箱!' },
                { type: 'email', message: '邮箱格式不正确!' }
              ]}
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              label="技术栈"
              name="techStack"
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              label="兴趣爱好"
              name="interests"
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              label="详细信息"
              name="details"
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Form>
        ) : (
          <>
            <Title level={3}>{aboutInfo.name}</Title>
            <Paragraph>{aboutInfo.intro}</Paragraph>
            
            <Descriptions 
              bordered 
              column={{ xs: 1, sm: 2 }}
              style={{ marginTop: 24 }}
            >
              <Descriptions.Item label="邮箱">{aboutInfo.email}</Descriptions.Item>
              <Descriptions.Item label="技术栈">{aboutInfo.techStack}</Descriptions.Item>
              <Descriptions.Item label="兴趣爱好" span={2}>{aboutInfo.interests}</Descriptions.Item>
              <Descriptions.Item label="详细信息" span={2}>
                <Paragraph>{aboutInfo.details}</Paragraph>
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Card>
    </div>
  );
};

export default AboutPage;